const ECG_COLORS = [
  '#00707c', // Teal
  '#fd6234', // Burnt Sienna  
  '#009fb2', // Sea Blue
  '#c50500', // Bonfire
  '#959595', // Grey
  '#585858'  // Darker Grey
];

export function generateColors(count) {
  if (count <= 0) return [];
  
  // Use base colors first
  if (count <= ECG_COLORS.length) {
    return ECG_COLORS.slice(0, count);
  }
  
  // For more colors, create variations
  const colors = [...ECG_COLORS];
  let baseIndex = 0;
  
  while (colors.length < count) {
    const baseColor = ECG_COLORS[baseIndex % ECG_COLORS.length];
    const variation = createVariation(baseColor, Math.floor(colors.length / ECG_COLORS.length));
    colors.push(variation);
    baseIndex++;
  }
  
  return colors;
}

function createVariation(hexColor, level) {
  const r = parseInt(hexColor.substr(1, 2), 16);
  const g = parseInt(hexColor.substr(3, 2), 16);
  const b = parseInt(hexColor.substr(5, 2), 16);
  
  // adjust brightness
  const factor = level % 2 === 0 ? 1 + (level + 1) * 0.3 : 1 - (level + 1) * 0.2;
  
  const newR = Math.min(255, Math.max(0, Math.round(r * factor)));
  const newG = Math.min(255, Math.max(0, Math.round(g * factor)));
  const newB = Math.min(255, Math.max(0, Math.round(b * factor)));
  
  return `#${newR.toString(16).padStart(2, '0')}${newG.toString(16).padStart(2, '0')}${newB.toString(16).padStart(2, '0')}`;
}